import React, { useEffect, useState } from "react";
import InquiryListing from "./InquiryListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setTotalItems,
} from "src/redux/slices/InquirySlice";
import Chip from "@mui/material/Chip";
import { useGetInquiryQuery } from "src/services/InquiryServices";
import { InquiryListResponse } from "src/models/Inquiry.model";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import { Tooltip } from "@mui/material";
import ATMCopyToClipboard from "src/components/UI/atoms/ATMCopyToClipboard/ATMCopyToClipboard";
import { IoCopyOutline } from "react-icons/io5";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import MoveToArchiveFormWrapper from "./MoveToArchive/MoveToArchiveFormWrapper";
import moment from "moment";

type Props = {};

const InquiryListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const [isCopied, setIsCopied] = useState(false);
  const [isOpenArchiveForm, setIsOpenArchiveForm] = useState(false);
  const [inquiryId, setInquiryId] = useState("");
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    inquirylabel,
    dispositionOne,
    dispositionTwo,
    dateFilter,
    nextFollowupEndDate,
    nextFollowupStartDate,
  } = useSelector((state: RootState) => state.inquiry);


  const { isLoading, isFetching, data } = useGetInquiryQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name"],
    page: page,
    filterBy: [
      {
        fieldName: "disposition_one",
        value: dispositionOne === null ? [] : [dispositionOne?.value],
      },
      {
        fieldName: "disposition_two",
        value: dispositionTwo === null ? [] : [dispositionTwo?.value],
      },
      {
        fieldName: "inquiryLabelId",
        value: inquirylabel === null ? [] : [inquirylabel?.value],
      },
    ],
    dateFilter: {
      dateFilterKey: "createdAt",
      startDate:dateFilter?.start_date ? moment( dateFilter?.start_date).format("YYYY-MM-DD")  : "",
      endDate:dateFilter?.end_date ?  moment(dateFilter?.end_date).format("YYYY-MM-DD") : "",
    },
    dateFilterForFollowup: {
      dateFilterKey: "next_followUp_date",
      startDate:nextFollowupStartDate ?  moment(nextFollowupStartDate).format("YYYY-MM-DD") : "",
      endDate:nextFollowupEndDate ?  moment(nextFollowupEndDate).format("YYYY-MM-DD") : "",
    },
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching, data]);

  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date - Time",
      extraClasses: "min-w-[100px] py-1 max-w-[150px]",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium text-[12px]">
            {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
          </div>
          <div className="text-[10px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row.createdAt, "hh:mm A")}
          </div>
        </div>
      ),
    },
    {
      field: "communicatedByName",
      extraClasses: "min-w-[130px] py-2 max-w-[170px]",
      headerName: "Inquired By",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: InquiryListResponse) => (
        <span className="capitalize text-[13px]"> {row?.communicatedByName} </span>
      ),
    },
    {
      field: "name",
      extraClasses: "min-w-[130px] py-2 max-w-[170px]",
      headerName: "Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: InquiryListResponse) => (
        <span className="capitalize text-[13px]"> {row?.name} </span>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile Number",
      flex: "flex-[1.5_1.5_0%]",
      extraClasses: "min-w-[150px] py-2 max-w-[150px]",
      renderCell: (row: InquiryListResponse) => (
        <div
          onClick={(e: any) => {
            e.stopPropagation();
          }}
          className="bg-stone-100 p-[6px] flex justify-between items-center rounded-xl  text-[12px] gap-4 cursor-defaul t"
        >
          {row?.mobile}
          <ATMCopyToClipboard
            tooltipTitle={isCopied ? "Copied" : "Copy"}
            copyText={row?.mobile}
            onCopy={() => {
              setIsCopied(true);
              setTimeout(() => {
                setIsCopied(false);
              }, 1000);
            }}
          >
            <IoCopyOutline className="cursor-pointer" />
          </ATMCopyToClipboard>
        </div>
      ),
    },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "min-w-[180px] max-w-[180px] ",
    //   align: "center",
    //   renderCell: (row: InquiryListResponse) => (
    //     <Tooltip title={row?.email}>
    //       <span className="text-[12px]"> {row?.email} </span>
    //     </Tooltip>
    //   ),
    // },
    {
      field: "inquiryLabelName",
      headerName: "Label",
      flex: "flex-[1.5_1.5_0%]",
      extraClasses: "max-w-[80px]",
      align: "center",
      renderCell: (row: InquiryListResponse) => (
        <Tooltip title={row?.inquiryLabelName}>
          <span className="text-[12px]"> {row?.inquiryLabelName} </span>
        </Tooltip>
      ),
    },
    {
      field: "dispositionFirstName",
      headerName: "DisPostion One",
      flex: "flex-[1.2_1.2_0%]",
      align: "center",
      extraClasses :'max-w-[150px]',
      renderCell: (row: InquiryListResponse) => (
          <span className="text-[12px]"> {row?.dispositionFirstName} </span>
      ),
    },
    {
      field: "dispositionSecondName",
      headerName: "DisPostion Second",
      flex: "flex-[1.5_1.5_0%]",
      align: "center",
      extraClasses :'max-w-[150px]',
      renderCell: (row: InquiryListResponse) => (
          <span className="text-[12px]"> {row?.dispositionSecondName} </span>
      ),
    },

    // {
    //   field: "inquiryType",
    //   headerName: "Type",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "max-w-[80px] ",
    //   align: "center",
    //   renderCell: (row: InquiryListResponse) => (
    //     <Tooltip title={row?.inquiryType}>
    //       <span className="text-[12px]"> {row?.inquiryType} </span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   field: "next_followUp_required",
    //   headerName: "FollowUp Required",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "max-w-[110px] ",
    //   align: "center",
    //   renderCell: (row: InquiryListResponse) => (
    //     <span className="text-[12px]"> {row?.next_followUp_required} </span>
    //   ),
    // },
    {
      field: "contact_them",
      headerName: `Next FollowUp On`,
      align: "center",
      flex: "flex-[1.5_1.5_0%]",
      extraClasses :'max-w-[150px]',
      renderCell: (row: InquiryListResponse) => (
        <span>
          {" "}
          {row?.contact_them === "ON_EVENT"
            ? row?.followup_batch_start_course?.map((course: any) => {
                return (
                  <Chip
                    key={course?._id}
                    label={course?.courseName}
                    className="me-2 my-1  "
                  />
                );
              })
            : row?.contact_them === "ON_DATE" && (
                <div>
                  <div className="text-slate-700 font-medium text-[12px]">
                    {formatedDateTimeIntoIst(
                      row?.next_followUp_date,
                      "DD MMM yyyy"
                    )}
                  </div>
                  <div className="text-[10px] font-medium text-slate-400 ">
                    {row?.next_followup_time !== "Invalid date" &&
                      row?.next_followup_time}
                  </div>
                </div>
              )}{" "}
        </span>
      ),
    },
    // {
    //   field: "course_name",
    //   headerName: "Course Name",
    //   extraClasses: "min-w-[240px] py-2 max-w-[240px]",
    //   flex: "flex-[1.5_1.5_0%]",
    //   renderCell: (row: any) => {
    //     return (
    //       <div className="flex flex-wrap w-full py-1">
    //         {row?.interested_course?.map((course: any) => {
    //           return (
    //             <Tooltip
    //               key={course?._id}
    //               title={course?.courseLabel?.courseName}
    //             >
    //               <Chip
    //                 label={course?.courseLabel?.courseName}
    //                 className="me-2 my-1"
    //               />
    //             </Tooltip>
    //           );
    //         })}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "fees",
    //   headerName: "Fees",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "max-w-[100px]",
    //   align: "center",
    //   renderCell: (row: InquiryListResponse) => (
    //     <div className="flex flex-col  py-1">
    //       {row?.interested_course?.map((course: any) => {
    //         return (
    //           <Chip
    //             key={course?._id}
    //             label={
    //               <span className="text-center text-[12px]">
    //                 &#8377; {course?.fees}
    //               </span>
    //             }
    //             className="me-2 my-1"
    //           />
    //         );
    //       })}
    //     </div>
    //   ),
    // },
    // {
    //   field: "Offer_Price",
    //   headerName: "Offer Fees",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "max-w-[100px] ",
    //   align: "center",
    //   renderCell: (row: InquiryListResponse) => (
    //     <div className="flex flex-col  py-1">
    //       {row?.interested_course?.map((course: any) => {
    //         return (
    //           <Chip
    //             key={course?._id}
    //             label={
    //               <span className="text-center text-[12px]">
    //                 &#8377; {course?.Offer_Price}
    //               </span>
    //             }
    //             className="me-2 my-1"
    //           />
    //         );
    //       })}
    //     </div>
    //   ),
    // },
    // {
    //   field: "communication_type",
    //   headerName: "Communication Type",
    //   flex: "flex-[1.5_1.5_0%]",
    //   extraClasses: "max-w-[120px] ",

    //   renderCell: (row: InquiryListResponse) => (
    //     <span className="text-[12px]"> {row?.communication_type} </span>
    //   ),
    // },
    {
      field: "lastSummaryNote",
      headerName: "Last Call Summary",
      flex: "flex-[1.5_1.5_0%]",
      extraClasses: "py-2  overflow-scroll min-w-[300px] max-h-[100px]  max-w-[300px]",
      renderCell: (row: InquiryListResponse) => (
        <p className="text-[13px] text-balance"> {row?.lastSummaryNote} </p>
      ),
    },
    {
      field: "lastFollowupDate",
      headerName: "Last Followup Date",
      flex: "flex-[1.5_1.5_0%]",
      align:'center',
      renderCell: (row: InquiryListResponse) => (
        <div>
        {row?.lastFollowupDate ? <div>  <div className="text-slate-700 font-medium text-[12px]">
            {formatedDateTimeIntoIst(row?.lastFollowupDate, "DD MMM yyyy")}
          </div>
          <div className="text-[10px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row?.lastFollowupDate, "hh:mm A")}
          </div></div>: <span>-</span> } 
        </div>
      ),
    },
    {
      field: "isArchived",
      headerName: "Move To Archive",
      flex: "flex-[1.5_1.5_0%]",
      extraClasses: "max-w-[100px]",
      renderCell: (row: InquiryListResponse) => (
        <div
          onClick={(e: any) => {
            e.stopPropagation();
          }}
        >
          {!row?.isArchived && (
            <ATMLoadingButton
              className="bg-cyan-500 h-[27px]"
              onClick={() => {
                setIsOpenArchiveForm(true);
                setInquiryId(row?._id);
              }}
            >
              Move
            </ATMLoadingButton>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <InquiryListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.INQUIRIES,
          actionName: UserModuleActionTypes.LIST,
          columns: columns,
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenArchiveForm && (
        <MoveToArchiveFormWrapper
          onClose={() => setIsOpenArchiveForm(false)}
          inquiryId={inquiryId}
        />
      )}
    </div>
  );
};

export default InquiryListingWrapper;
